<div class="assistant-wrapper">
  <div *ngIf="loading">
    <loader-overlay [styles]="{ backgroundColor: 'transparent', backdropFilter: 'none' }"> </loader-overlay>
  </div>
  <div *ngIf="!loading" class="assistant-container">
    <div class="page-limit wide">
      <div class="settings-header">
        <u-button
          [label]="'Back to Assistants'"
          (onClick)="goBack()"
          [versionNumber]="2"
          [sizeElement]="'extra-small'"
          [typeElement]="'secondary'"
          [fontIcon]="'chevron-left'"
          [styleType]="'text'"
        >
        </u-button>
        @if (originalAssistant?.id) {
          <assistant-header-line #assistantHeaderLineRef [assistant]="assistantForHeader()"></assistant-header-line>
        }
      </div>
    </div>
    <div class="scrolling-area" [ngClass]="{ 'scrolling-area-readonly': assistant?.readOnly }">
      <ng-scrollbar visibility="hover">
        <cdk-virtual-scroll-viewport itemSize="40" ngScrollbarView smoothScroll scrollViewport [class.virtual-scroll]="true">
          <div class="page-limit">
            <div class="assistant-header">
              <u-emoji-picker
                *ngIf="experienceType === 'general'; else regularIcon"
                class="header-icon"
                [closeOnSelect]="true"
                (selectedEmoji)="onSelectedEmoji($event)"
                [model]="selectedBaseAIModel()?.icon || assistant.icon"
                [iconInSvg]="selectedBaseAIModel()?.icon ? true : false"
                [emojiUnicode]="assistant?.settings?.emoji"
                [readonly]="assistant.readOnly"
                [spriteEmojiSize]="24"
                [placeholderFontSize]="'14px'"
              ></u-emoji-picker>
              <ng-template #regularIcon>
                <u-icon
                  *ngIf="assistant?.icon"
                  class="header-icon"
                  [model]="assistant.icon"
                  [styles]="{ fontSize: '24px', height: '24px', width: '24px' }"
                ></u-icon>
              </ng-template>
              @if (['general', 'rfp', 'salesforce'].includes(experienceType)) {
                <questionnaire-section
                  [title]="title()"
                  [disabledButton]="!isEqualAssistant"
                  [assistant]="assistant"
                  (changeTitle)="onChangeName($event)"
                ></questionnaire-section>
              } @else {
                <div
                  #assistantName
                  class="header"
                  data-cy="assistant-header"
                  [pTooltip]="titleTooltip"
                  tooltipPosition="top"
                  tooltipStyleClass="u-tooltip"
                >
                  {{ title() }}
                </div>
              }
              <span
                #assistantSubName
                *ngIf="subtitle"
                class="subtitle"
                [pTooltip]="subtitleTooltip"
                tooltipPosition="top"
                tooltipStyleClass="u-tooltip"
                >{{ subtitle }}</span
              >
              @if (experienceType === 'general') {
                <u-button
                  [label]="'Open Chat'"
                  [disabled]="
                    !assistant?.id || !isEqualAssistant || assistant.settings?.general?.displayOnChatPage === false || loadingSaveButton
                  "
                  (onClick)="openChat()"
                  type="secondary"
                  elementSize="small"
                  class="open-chat-button"
                ></u-button>
              }
            </div>
            <div class="description-container" *ngIf="experienceType === 'general'; else headerInfo">
              <u-edit-text
                *ngIf="!assistant.readOnly; else descriptionReadonly"
                class="no-state inline-input-description"
                data-cy="input-description"
                [placeholder]="assistant.settings?.description ?? 'Add description (optional)'"
                [focusNoColor]="true"
                [ignoreEnter]="true"
                [selectTextOnFocus]="true"
                [maxLength]="280"
                [autoFocus]="componentFocused === AssistantComponentFocused.DESCRIPTION"
                (onTextChange)="formInputChanged.next($event)"
                (outsideClick)="
                  componentFocused === AssistantComponentFocused.DESCRIPTION && (componentFocused = AssistantComponentFocused.APPS)
                "
                (onEnterPressed)="componentFocused = AssistantComponentFocused.APPS"
                (onClick)="componentFocused = AssistantComponentFocused.DESCRIPTION"
              ></u-edit-text>
              <ng-template #descriptionReadonly>
                <div *ngIf="!!assistant?.settings?.description" class="assitant-description-readonly">
                  {{ assistant?.settings?.description }}
                </div>
              </ng-template>
            </div>
            <ng-template #headerInfo>
              <div class="assistant-header-info">
                {{ assistant.readOnly ? assistantContent.headerInfoReadonly[experienceType] : assistantContent.headerInfo[experienceType] }}
                @if (assistantContent.learnMoreUrl[experienceType]) {
                  <a (click)="openLearnMore(assistantContent.learnMoreUrl[experienceType])" class="learn-more-btn"> Learn More </a>
                }
              </div>
            </ng-template>
            <assistant-knowledge
              *ngIf="experienceType === 'general'"
              [assistant]="assistant"
              (updateProperties)="onChangeProperties($event)"
              (updateAssistantModel)="updateAssistantModel($event)"
              (updateDisplayDataSource)="isDataSourceDisplayed.set($event)"
            ></assistant-knowledge>
            @if (experienceType !== 'general' || isDataSourceDisplayed()) {
              <div class="assistant-sub-header with-button">
                <div class="assistant-apps-header">
                  <div class="title">{{ assistantContent.apps }}</div>
                </div>
                @if (showAddQuery) {
                  <u-button
                    [versionNumber]="2"
                    [label]="assistantContent.addApp"
                    [styleType]="'outlined'"
                    [typeElement]="'secondary'"
                    [stateElement]="!allowAddQuery ? 'disabled' : 'regular'"
                    [sizeElement]="'small'"
                    fontIcon="mac-maximize-plus"
                    (onClick)="addQuery()"
                  >
                  </u-button>
                }
              </div>
              <div class="knowledge-info" *ngIf="assistant?.experienceType === 'general'">
                <div>{{ assistantContent.assistantDisclaimerLine1 }}</div>
                <div>{{ assistantContent.assistantDisclaimerLine2 }}</div>
              </div>
              @if (assistantContent.warningsContent[experienceType]?.[assistant.permissionRole]) {
                <div class="assistant-warning">
                  <u-icon
                    [model]="{ type: 'font', value: 'icon-exclamation-mark-circle' }"
                    [styles]="{ color: 'var(--yellow-600)', fontSize: '16px' }"
                  >
                  </u-icon>
                  <span>{{ assistantContent.warningsContent[experienceType][assistant.permissionRole] }}</span>
                </div>
              }

              @if (experienceType === 'slack') {
                @if (channelFilters?.length) {
                  <div class="results-filters-box-line">
                    <div class="filter">
                      <div class="channel-filters-container">
                        <results-filters-box
                          class="results-filters-box-item"
                          [filters]="channelFilters"
                          (filterChange)="onChannelFilterChange($event)"
                        >
                        </results-filters-box>
                      </div>
                      <u-toggle-switch
                        class="channel-toggle-button"
                        [checked]="!channelDataSource.disabled"
                        type="small"
                        (onChange)="changeChannelToggle()"
                        [pTooltip]="
                          channelDataSource.disabled
                            ? 'Open to see answers from this channel'
                            : 'Close to disable answers from this channel'
                        "
                        [tooltipDisabled]="!!assistant.readOnly"
                        tooltipPosition="top"
                        tooltipStyleClass="u-tooltip"
                        [disabled]="!!assistant.readOnly"
                      ></u-toggle-switch>
                    </div>
                  </div>
                } @else {
                  <div class="filter-ghost">
                    <ng-container *ngTemplateOutlet="ghostTemplate; context: { countLine: 4 }"></ng-container>
                  </div>
                }
              }

              @if (initLoadFiltersApp() && !draftMode) {
                <div class="filter-ghost full-height">
                  <ng-container *ngTemplateOutlet="ghostTemplate; context: { countLine: 8 }"></ng-container>
                </div>
              }

              @if (dataSourceExist || draftMode) {
                <div class="assistant-apps" data-cy="assistant-apps">
                  <div
                    class="results-filters-box-line"
                    data-cy="app-line"
                    *ngFor="let sourceView of filterSourceViews || []; let index = index"
                  >
                    <div class="filter">
                      <results-filters-box
                        class="results-filters-box-item"
                        [id]="'filters-' + index"
                        [filters]="sourceView?.filterValues"
                        (filterChange)="onFilterChange($event, index)"
                        [index]="index"
                        (onClick)="onClickFilterBox($event, index)"
                      >
                      </results-filters-box>
                      <assistant-filter-buttons
                        [index]="index"
                        [filterSourceView]="sourceView"
                        [filtersDataSourcesCount]="assistant.filtersDataSources?.length + (assistant.channelDataSource ? 1 : 0)"
                        [permissionRole]="assistant.permissionRole"
                        [disableTiering]="disableTieringTypes?.includes(experienceType)"
                        (addPriority)="addPriority(index)"
                        (onRemoveLine)="onRemoveLine(index)"
                      >
                      </assistant-filter-buttons>
                    </div>

                    @if (sourceView.warningMessage) {
                      <div class="message">
                        @switch (sourceView.warningMessage.type) {
                          @case ('warning') {
                            <div class="warning-message">
                              <div class="warning-icon"><div class="icon">!</div></div>
                              <div>{{ sourceView.warningMessage.text }}</div>
                            </div>
                          }
                          @case ('error') {
                            <span class="error-message">{{ sourceView.warningMessage.text }}</span>
                          }
                        }
                      </div>
                    }
                  </div>
                  @if (showAddQuery) {
                    <u-button
                      [versionNumber]="2"
                      [label]="assistantContent.addApp"
                      [styleType]="'text'"
                      [typeElement]="'primary'"
                      [stateElement]="!allowAddQuery ? 'disabled' : 'regular'"
                      [sizeElement]="'large'"
                      fontIcon="mac-maximize-plus"
                      (onClick)="addQuery()"
                    >
                    </u-button>
                  }
                </div>
              } @else {
                <div class="assistant-no-data">
                  {{ assistantContent.noAppsMessage }}
                </div>
              }
            }
            @if (experienceType === 'slack') {
              <bot-behavior
                #botBehaviorRef
                [assistant]="assistant"
                [originalAssistant]="originalAssistant"
                [disabled]="originalAssistant?.permissionRole === 'viewer' || !isAssistantEditable()"
                (updateData)="onChangeProperties($event)"
              ></bot-behavior>
            }
            <assistant-instructions
              [assistant]="assistant"
              [originalAssistant]="originalAssistant"
              [disabled]="originalAssistant?.permissionRole === 'viewer' || !isAssistantEditable()"
              (updateInstructions)="onChangeProperties($event)"
            ></assistant-instructions>
            <ng-container [ngSwitch]="experienceType">
              <ng-container *ngSwitchCase="'slack'">
                <slack-preferences [assistant]="originalAssistant" (updateProperties)="onChangeProperties($event)"></slack-preferences>
              </ng-container>
              <ng-container *ngSwitchCase="'teams'">
                <teams-preferences [assistant]="assistant" (updateProperties)="onChangeProperties($event)"></teams-preferences>
              </ng-container>
              <ng-container *ngSwitchCase="'general'">
                <general-preferences
                  [assistant]="assistant"
                  [isAssistantEditable]="isAssistantEditable()"
                  (updateProperties)="onChangeProperties($event)"
                ></general-preferences>
              </ng-container>
            </ng-container>
          </div>
        </cdk-virtual-scroll-viewport>
      </ng-scrollbar>
    </div>

    <div class="assistant-footer page-limit">
      <div class="button-content">
        <u-button
          *ngIf="experienceType === 'general' && assistantContent.learnMoreUrl[experienceType]"
          [label]="'Learn More'"
          class="link-button"
          type="link"
          (mousedown)="openLearnMore(assistantContent.learnMoreUrl[experienceType])"
        ></u-button>
        <div class="assistant-footer-actions" *ngIf="!assistant.readOnly">
          <u-button
            [label]="assistantContent.cancel"
            [disabled]="isEqualAssistant"
            type="secondary"
            data-cy="assistant-cancel"
            (onClick)="cancel()"
          ></u-button>
          <u-button
            [label]="loadingSaveButton ? ' ' : assistantContent.save"
            [loading]="loadingSaveButton"
            [disabled]="isEqualAssistant || !isValidForm()"
            type="primary"
            data-cy="assistant-save"
            (onClick)="save()"
          ></u-button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #ghostTemplate let-countLine="countLine">
  <div class="item-container" *ngFor="let i of countLine | fill; index as index">
    <div class="ghost"></div>
  </div>
</ng-template>
